import React from 'react';
import './Card.css';

/**
 *   <Card>
 *     <Card.Header>
 *       <h2>Title</h2>
 *       <Button>Action</Button>
 *     </Card.Header>
 *     <Card.Body>...</Card.Body>
 *   </Card>
 */
function Card({ children, className = '', padded = true }) {
  return (
    <section className={`card${padded ? ' card--padded' : ''} ${className}`}>
      {children}
    </section>
  );
}
Card.Header = function Header({ children, className = '' }) {
  return <header className={`card__header ${className}`}>{children}</header>;
};
Card.Body = function Body({ children, className = '' }) {
  return <div className={`card__body ${className}`}>{children}</div>;
};
Card.Footer = function Footer({ children, className = '' }) {
  return <footer className={`card__footer ${className}`}>{children}</footer>;
};

export default Card;
